import { Locale } from '@data/enums';
import { useLanguage } from '@data/hooks';
import { BsGlobe } from 'react-icons/bs';
import { useProductType } from '@data/hooks/useRoute';
import { pushDataLayer } from '@/utils/googleAnalytics';
import { useGAFactory } from '@/data/hooks/useGAFactory';

export const LanguageSwitcher = () => {
  const { updateLocale, locale } = useLanguage();
  const GAFactory = useGAFactory();

  const handleGA = () => {
    pushDataLayer(GAFactory('select_language', {}));
  };

  return (
    <button
      className="flex items-center"
      title={
        locale === Locale.EN ? `Switch to Bahasa Malaysia` : `Switch to English`
      }
      onClick={() => {
        updateLocale();
        handleGA();
      }}
    >
      <BsGlobe className="text-gray-400" />
      <span className="text-lg font-medium italic text-gray-400">
        {locale.toLocaleUpperCase()}
      </span>
    </button>
  );
};
